import { __awaiter, __generator } from "tslib";
import { fetchOfficeComponentContext } from '@office-start/component-context-service';
import { fetchFeatureGates } from '@office-start/feature-gates-service';
import { fetchFeatureSettings } from '@office-start/feature-settings-service';
import { logErrorEvent } from '@office-start/instrumentation-service';
import { KnownInstrumentationEvents, } from '@office-start/instrumentation-types';
import { mark as markPerformance } from '@office-start/performance-service';
import { logError } from '@office-start/telemetry-service';
import { fetchUserEntitlements } from '@office-start/user-entitlements-service';
export function prefetchNorthStar() {
    return __awaiter(this, void 0, void 0, function () {
        var message, fetchDataPromisesObject, prefetchConfigsEnabled, err_1, message;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 3, , 4]);
                    try {
                        markPerformance('PrefetchNorthStar_Started');
                    }
                    catch (err) {
                        message = "Invoked markPerformance in prefetchNorthStar function, but encountered an error : ".concat(err);
                        logErrorEvent(KnownInstrumentationEvents.PrefetchNorthStarMarkPerformanceError, (_a = {},
                            _a["Error" /* InstrumentationParam.Error */] = message,
                            _a));
                        // TODO: Remove above telemetry once migrated over to OTEL
                        logError({
                            eventName: KnownInstrumentationEvents.PrefetchNorthStarMarkPerformanceError,
                            errorType: 'NorthStarConfig_Error',
                            message: message,
                        });
                    }
                    fetchDataPromisesObject = {
                        featureGatesPromise: fetchFeatureGates(),
                        featureSettingsPromise: fetchFeatureSettings(),
                        userEntitlementsPromise: fetchUserEntitlements(),
                        contextPromise: fetchOfficeComponentContext(),
                    };
                    prefetchConfigsEnabled = true;
                    if (!prefetchConfigsEnabled) return [3 /*break*/, 2];
                    return [4 /*yield*/, runAllPrefetchers()];
                case 1:
                    _c.sent();
                    _c.label = 2;
                case 2: return [3 /*break*/, 4];
                case 3:
                    err_1 = _c.sent();
                    message = "Invoked prefetchNorthStar function, but encountered an error: ".concat(err_1);
                    logErrorEvent(KnownInstrumentationEvents.PrefetchNorthStarError, (_b = {},
                        _b["Error" /* InstrumentationParam.Error */] = message,
                        _b));
                    // TODO: Remove above telemetry once migrated over to OTEL
                    logError({
                        eventName: KnownInstrumentationEvents.PrefetchNorthStarError,
                        errorType: 'NorthStarConfig_Error',
                        message: message,
                    });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}
function runAllPrefetchers() {
    return __awaiter(this, void 0, void 0, function () {
        var prefetchAppGalleryConfig, prefetchCapabilities, prefetchEdgeworthConfig, prefetchInstallConfig, prefetchMruConfig, prefetchSharedContext, prefetchShellConfig, prefetchTemplatesConfig;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, import('@office-start/app-gallery-config-service')];
                case 1:
                    prefetchAppGalleryConfig = (_a.sent()).prefetchAppGalleryConfig;
                    return [4 /*yield*/, import('@office-start/capabilities-service')];
                case 2:
                    prefetchCapabilities = (_a.sent()).prefetchCapabilities;
                    return [4 /*yield*/, import('@office-start/edgeworth-config-service')];
                case 3:
                    prefetchEdgeworthConfig = (_a.sent()).prefetchEdgeworthConfig;
                    return [4 /*yield*/, import('@office-start/install-config-service')];
                case 4:
                    prefetchInstallConfig = (_a.sent()).prefetchInstallConfig;
                    return [4 /*yield*/, import('@office-start/mru-config-service')];
                case 5:
                    prefetchMruConfig = (_a.sent()).prefetchMruConfig;
                    return [4 /*yield*/, import('@office-start/context-service')];
                case 6:
                    prefetchSharedContext = (_a.sent()).prefetchSharedContext;
                    return [4 /*yield*/, import('@office-start/shell-config-service')];
                case 7:
                    prefetchShellConfig = (_a.sent()).prefetchShellConfig;
                    return [4 /*yield*/, import('@office-start/templates-config-service')];
                case 8:
                    prefetchTemplatesConfig = (_a.sent()).prefetchTemplatesConfig;
                    // TODO: add prefetchEdgeworthRecentData method call here so data-prefetch-service no longer needs to run during app.ts bootstrap.
                    return [4 /*yield*/, Promise.all([
                            prefetchAppGalleryConfig(),
                            prefetchCapabilities(),
                            prefetchEdgeworthConfig(),
                            prefetchInstallConfig(),
                            prefetchMruConfig(),
                            prefetchSharedContext(),
                            prefetchShellConfig(),
                            prefetchTemplatesConfig(),
                        ])];
                case 9:
                    // TODO: add prefetchEdgeworthRecentData method call here so data-prefetch-service no longer needs to run during app.ts bootstrap.
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=prefetchNorthStar.js.map